import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Plus, XIcon } from "lucide-react";
import React from "react";

interface RadioTypeProps {
  data: any;
  onDataChanged: (data: any) => void;
}

const RadioType: React.FC<RadioTypeProps> = ({ data, onDataChanged }) => {
  // data.options is an array of strings

  const handleChange =
    (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const newOptions = [...data.options];
      newOptions[index] = e.target.value;
      onDataChanged({ ...data, options: newOptions });
    };

  const deleteOption = (index: number) => () => {
    onDataChanged({
      ...data,
      options: data.options.filter((_: any, i: number) => i !== index),
    });
  };

  return (
    <div className="flex flex-col gap-2">
      <RadioGroup>
        {data.options.map((option: string, index: number) => (
          <div key={index} className="flex items-center gap-2">
            <RadioGroupItem value={index.toString()} id={index.toString()} />

            <Input
              className="flex-1 text-sm"
              value={option}
              placeholder="New Option"
              onChange={handleChange(index)}
            />
            <Button
              onClick={deleteOption(index)}
              variant="ghost"
              size="icon"
            >
              <XIcon className="h-4 w-4" />
            </Button>
          </div>
        ))}
      </RadioGroup>
      <Button
        variant="ghost"
        className="w-fit px-0 text-primary hover:bg-transparent"
        onClick={() =>
          onDataChanged({ ...data, options: [...data.options, ""] })
        }
      >
        <Plus className="mr-1 h-4 w-4" />
        Add Option
      </Button>
    </div>
  );
};

export default RadioType;
